'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import type { ClassValue } from 'clsx';
import type { ReactNode } from 'react';
import { useTopNav } from '@src/components/TopNavV4/TopNavContext';
import { TopNavMobileCloseHeader } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileCloseHeader';
import { TopNavMobileMenu } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileMenu';
import { TopNavMobileSubMenu } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileSubMenu';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { cn } from '@src/utils/tailwind';
const asideClassNames = 'size-full bg-bodi-black-text bg-linear-to-t from-white/10 to-white/0 text-white z-max duration-200 transition-all transition ease-out flex flex-col';
const Panel = t0 => {
  const $ = _c(17);
  const {
    open,
    onClose,
    className,
    content
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(asideClassNames, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose) {
    t2 = <TopNavMobileCloseHeader onClick={onClose} />;
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== content) {
    t3 = <div className="flex-1 overflow-y-auto">{content}</div>;
    $[4] = content;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <TransitionChild><DialogPanel className={t1}>{t2}{t3}</DialogPanel></TransitionChild>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== open || $[11] !== t4) {
    t5 = <Transition show={open} as="div" className="fixed inset-0">{t4}</Transition>;
    $[10] = open;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onClose || $[14] !== open || $[15] !== t5) {
    t6 = <Dialog transition={true} className="relative z-max transition duration-200 ease-out" onClose={onClose} open={open} static={true}>{t5}</Dialog>;
    $[13] = onClose;
    $[14] = open;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export const TopNavMobileSlidingPanel = () => {
  const $ = _c(20);
  const {
    isExpanded,
    isMobileSubExpanded,
    setExpanded,
    setMobileSubExpanded
  } = useTopNav();
  const {
    isDesktop
  } = useBreakpoints();
  const t0 = isExpanded && !isMobileSubExpanded && !isDesktop;
  let t1;
  if ($[0] !== setExpanded) {
    t1 = () => setExpanded(false);
    $[0] = setExpanded;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TopNavMobileMenu />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t0 || $[4] !== t1) {
    t3 = <Panel open={t0} onClose={t1} content={t2} className="data-closed:-translate-x-full" />;
    $[3] = t0;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = isMobileSubExpanded && !isDesktop;
  let t5;
  if ($[6] !== setExpanded || $[7] !== setMobileSubExpanded) {
    t5 = () => {
      setExpanded(false);
      setMobileSubExpanded(false);
    };
    $[6] = setExpanded;
    $[7] = setMobileSubExpanded;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TopNavMobileSubMenu />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = !isExpanded;
  let t8;
  if ($[10] !== isExpanded || $[11] !== t7) {
    t8 = {
      "data-closed:translate-x-full": isExpanded,
      "data-closed:-translate-x-full": t7
    };
    $[10] = isExpanded;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t8) {
    t9 = <Panel open={t4} onClose={t5} content={t6} className={t8} />;
    $[13] = t4;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t3 || $[18] !== t9) {
    t10 = <>{t3}{t9}</>;
    $[17] = t3;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};